'use client';
import React, { useState, useEffect } from 'react';

export default function DriveXFloating() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowScrollTop(window.scrollY > 400);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const waNumber = process.env.NEXT_PUBLIC_BT_SAAS_WHATSAPP || '573000000000';
  const waUrl = `https://wa.me/${waNumber}?text=Hola, quiero información sobre DriveX.`;

  return (
    <>
      {/* WhatsApp float */}
      <a
        href={waUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="dx-wa-pulse"
        style={{
          position: 'fixed', bottom: '24px', right: '24px', zIndex: 200,
          width: '56px', height: '56px', borderRadius: '50%',
          background: '#25D366', display: 'flex', alignItems: 'center', justifyContent: 'center',
          textDecoration: 'none', fontSize: '24px',
        }}
        aria-label="WhatsApp"
      >
        💬
      </a>

      {/* Scroll to top */}
      <button
        onClick={scrollToTop}
        aria-label="Volver arriba"
        style={{
          position: 'fixed', bottom: '24px', left: '24px', zIndex: 200,
          width: '40px', height: '40px', borderRadius: '50%',
          background: '#3A3A3A', border: 'none', cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: '16px', color: '#AAAAAA',
          opacity: showScrollTop ? 1 : 0,
          transform: showScrollTop ? 'translateY(0)' : 'translateY(10px)',
          transition: 'opacity 0.3s ease, transform 0.3s ease',
          pointerEvents: showScrollTop ? 'auto' : 'none',
        }}
      >
        ↑
      </button>
    </>
  );
}
